import axios from "@/api/axiosInstance";
import { FetchProductStoreOrderResponse } from "./types";

export const fetchProductStoreOrder = async (
  uuid: string,
): Promise<FetchProductStoreOrderResponse> => {
  const response = await axios.get<FetchProductStoreOrderResponse>(
    `/api/private/product-store/order/${uuid}`,
  );
  return response.data;
};
